import { gql } from "@apollo/client";

export const GENERATE_REFERRAL_CODE = gql`
  mutation GenerateReferralCode {
    generateReferralCode {
      success
      referralCode
      referralLink
      error
    }
  }
`;

export const GET_REFERRAL_DASHBOARD = gql`
  query GetReferralDashboard {
    getReferralDashboard {
      success
      referralCode
      referralLink
      totalEarned
      availableBalance
      totalPaidOut
      referralsCount
      error
    }
  }
`;

export const GET_MY_REFERRALS = gql`
  query GetMyReferrals($userId: uuid!, $limit: Int!, $offset: Int!) {
    users(
      where: { referred_by: { _eq: $userId } }
      order_by: { created_at: desc }
      limit: $limit
      offset: $offset
    ) {
      id
      name
      email
      telegram_id
      created_at
      is_active
    }
    users_aggregate(where: { referred_by: { _eq: $userId } }) {
      aggregate {
        count
      }
    }
    accruals: referral_balance_ledger(
      where: { user_id: { _eq: $userId }, entry_type: { _eq: "ACCRUAL" } }
    ) {
      source_user_id
      amount
    }
  }
`;

export const GET_MY_REFERRAL_LEDGER = gql`
  query GetMyReferralLedger($userId: uuid!, $limit: Int!, $offset: Int!) {
    referral_balance_ledger(
      where: { user_id: { _eq: $userId } }
      order_by: { created_at: desc }
      limit: $limit
      offset: $offset
    ) {
      id
      entry_type
      amount
      balance_after
      tier
      description
      created_at
      source_user {
        name
      }
    }
  }
`;
